"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mval = void 0;
const constants_1 = require("../constants");
const MvalNode_1 = require("./MvalNode");
const MvalApi_1 = require("./MvalApi");
const constants_2 = require("./constants");
const json_crdt_1 = require("../../json-crdt");
const Extension_1 = require("../../json-crdt/extensions/Extension");
exports.mval = new Extension_1.Extension(constants_1.ExtensionId.mval, constants_2.MNEMONIC, MvalNode_1.MvalNode, MvalApi_1.MvalApi, (value) => json_crdt_1.s.arr(value === undefined ? [] : [json_crdt_1.s.json(value)]));
